/* eslint-disable @typescript-eslint/no-explicit-any */
import RESISTANT_IMG_16 from '../img/Approved_16.svg';
import RESISTANT_IMG_24 from '../img/Approved_24.svg';
import NOT_RESITANT_IMG_16 from '../img/Error_16.svg';
import NOT_RESITANT_IMG_24 from '../img/Error_24.svg';
import CONDITIONALLY_RESISTANT_IMG_16 from '../img/Warning_16.svg';
import CONDITIONALLY_RESISTANT_IMG_24 from '../img/Warning_24.svg';
import NOT_SPECIFIED_IMG_16 from '../img/help_16-g.svg';
import NOT_SPECIFIED_IMG_24 from '../img/help_24-g.svg';

// interface TypeSize {
//   SIZE_16: string;
//   SIZE_24: string;
// }

// interface ResistanceTypeIMG {
//   ALL: string;
//   RESISTANT: TypeSize;
//   CONDITIONALLY_RESISTANT: TypeSize;
//   NOT_RESISTANT: TypeSize;
//   NOT_SPECIFIED: TypeSize;
// }

export const resistanceTypeImg: any = {
  ALL: '',
  RESISTANT: {
    SIZE_16: RESISTANT_IMG_16,
    SIZE_24: RESISTANT_IMG_24,
  },
  CONDITIONALLY_RESISTANT: {
    SIZE_16: CONDITIONALLY_RESISTANT_IMG_16,
    SIZE_24: CONDITIONALLY_RESISTANT_IMG_24,
  },
  NOT_RESISTANT: {
    SIZE_16: NOT_RESITANT_IMG_16,
    SIZE_24: NOT_RESITANT_IMG_24,
  },
  NOT_SPECIFIED: {
    SIZE_16: NOT_SPECIFIED_IMG_16,
    SIZE_24: NOT_SPECIFIED_IMG_24,
  },
};
